/**
 * Display helpers for the Pipeline drill-down and the ticket page (#50).
 */

import type { PipelineTicket, TicketEditLock } from './hooks';

const METHOD_LABELS: Readonly<Record<string, string>> = {
  PER_BBL: 'Per bbl',
  HOURLY: 'Hourly',
  FLAT_RATE: 'Per load',
  PER_UNIT: 'Per unit',
};

export function billingMethodLabel(method: string | null): string {
  if (method === null) return '—';
  return METHOD_LABELS[method] ?? method;
}

/** The ticket number people know (the haul id), else a short form of the job id. */
export function ticketLabel(haulId: string | null, jobId: string): string {
  return haulId ?? `#${jobId.slice(0, 8)}`;
}

/**
 * How a row relates to the selected month, shown only while "All unbilled" is on: none of
 * its unbilled lines bill this month, some of them do, or all do (no marker).
 */
export function periodMarker(t: PipelineTicket): 'OUTSIDE' | 'PARTLY_OUTSIDE' | null {
  if (t.eventsInPeriod === 0) return 'OUTSIDE';
  if (t.eventsInPeriod < t.eventCount) return 'PARTLY_OUTSIDE';
  return null;
}

/** Why billing can't edit the ticket, in words. */
export function lockMessage(lock: TicketEditLock): string {
  switch (lock.code) {
    case 'ON_INVOICE':
      return `On invoice ${lock.invoiceNumber} (${lock.invoiceStatus}). Void it to edit.`;
    case 'NOT_TO_BE_INVOICED':
      return `This ticket is ${lock.status.replaceAll('_', ' ').toLowerCase()}, not waiting to be invoiced.`;
    case 'NO_UNBILLED_LINES':
      return 'This ticket has no unbilled lines.';
  }
}
